import { render, staticRenderFns } from "./LandfillPage.vue?vue&type=template&id=507dd9c4&scoped=true"
import script from "./LandfillPage.vue?vue&type=script&lang=js"
export * from "./LandfillPage.vue?vue&type=script&lang=js"
import style0 from "./LandfillPage.vue?vue&type=style&index=0&id=507dd9c4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507dd9c4",
  null
  
)

export default component.exports